module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/banners/tax-credit-rc-ddfce8196a5d7d4ef272a40f5c69a3f0.svg";